var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect31, _rect32, _rect33, _rect34, _rect35;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 213,
    viewBox: "0 0 172 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.771,
    cy: 202.343,
    rx: 61.2921,
    ry: 9.82246,
    fill: "#EAEFFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2378,
    y: 62.4865,
    width: 151.288,
    height: 103.615,
    rx: 2.5,
    fill: "white",
    stroke: "#EAEFFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5176,
    y: 64.6496,
    width: 43.1134,
    height: 9.51046,
    fill: "#2E62E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.6328,
    y: 66.9321,
    width: 102.916,
    height: 7.22795,
    fill: "#E5E5E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 78.3447,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 88.2355,
    width: 145.682,
    height: 4.56502,
    fill: "#2E62E6",
    fillOpacity: 0.56
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 98.1263,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 117.908,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1172,
    y: 162.037,
    width: 79.127,
    height: 4.17227,
    transform: "rotate(-90 35.1172 162.037)",
    fill: "#E5E5E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 102.919,
    y: 162.037,
    width: 79.127,
    height: 4.17227,
    transform: "rotate(-90 102.919 162.037)",
    fill: "#E5E5E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 65.3662,
    y: 159.754,
    width: 79.127,
    height: 4.17227,
    transform: "rotate(-90 65.3662 159.754)",
    fill: "#E5E5E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 127.799,
    width: 145.682,
    height: 4.56502,
    fill: "#2E62E6",
    fillOpacity: 0.22
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 137.689,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 147.581,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 157.471,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8628,
    y: 108.017,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4375,
    y: 73.5828,
    width: 151.288,
    height: 103.615,
    rx: 2.5,
    fill: "white",
    stroke: "#EAEFFC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 3.71729,
    y: 75.7459,
    width: 43.1134,
    height: 9.51046,
    fill: "#2E62E6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8325,
    y: 78.0284,
    width: 102.916,
    height: 7.22795,
    fill: "#E5E5E5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 89.4411,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 99.3318,
    width: 145.682,
    height: 4.56502,
    fill: "#2E62E6",
    fillOpacity: 0.56
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 109.223,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 129.004,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3174,
    y: 173.133,
    width: 79.127,
    height: 4.17227,
    transform: "rotate(-90 26.3174 173.133)",
    fill: "#E5E5E5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1187,
    y: 173.133,
    width: 79.127,
    height: 4.17227,
    transform: "rotate(-90 94.1187 173.133)",
    fill: "#E5E5E5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5659,
    y: 170.851,
    width: 79.127,
    height: 4.17227,
    transform: "rotate(-90 56.5659 170.851)",
    fill: "#E5E5E5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 138.896,
    width: 145.682,
    height: 4.56502,
    fill: "#2E62E6",
    fillOpacity: 0.22
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 148.786,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 158.677,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 168.567,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 119.113,
    width: 145.682,
    height: 4.56502,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8415 41.2487C99.8415 41.2487 101.187 38.8888 101.382 38.5212C101.576 38.1551 101.467 36.9961 101.229 35.676C100.99 34.3559 100.091 32.6809 99.8808 32.5916C99.6731 32.5002 99.5042 32.3102 98.9357 32.4304C98.3666 32.5526 97.9498 32.9745 97.9498 32.9745C97.9498 32.9745 97.1791 32.7879 96.7054 33.3479C96.7054 33.3479 95.9731 33.2047 95.5365 33.9303C95.5365 33.9303 94.8173 33.8107 94.5443 34.3667C94.5443 34.3667 94.6513 35.5272 94.569 35.9695C94.4877 36.4113 95.1257 39.4053 95.843 41.6495C95.843 41.6495 96.9676 42.9446 99.8415 41.2487Z",
    fill: "#DBA585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.703 37.0279C98.703 37.0279 97.553 37.6262 97.3533 37.9073C97.1536 38.1899 94.5281 36.8564 94.5281 36.8564C94.5281 36.8564 97.6176 36.0696 98.703 37.0279Z",
    fill: "#BD8A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8458 33.4353L83.5356 47.602L90.2985 45.0719L84.6065 30.9046L77.8458 33.4353Z",
    fill: "#2D284D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.909 22.7896C106.975 22.9627 107.051 23.1304 107.136 23.2903C108.724 20.9489 111.133 18.7933 114.131 17.1479C112.864 16.2629 111.19 16.0005 109.645 16.599C107.18 17.5543 105.952 20.3301 106.909 22.7896ZM113.096 38.7268C114.051 41.188 116.832 42.4115 119.295 41.4579C120.842 40.8599 121.902 39.5402 122.239 38.0336C118.915 38.8372 115.68 38.864 112.927 38.2054C112.972 38.38 113.028 38.5531 113.096 38.7268ZM116 16.2254C116.291 16.0968 116.587 15.9704 116.888 15.8513L125.151 37.1346C124.849 37.2498 124.546 37.3573 124.243 37.4569C124.065 39.9607 122.478 42.2677 119.984 43.2328C116.542 44.5654 112.653 42.8532 111.319 39.4156C111.082 38.8037 110.943 38.1792 110.889 37.5564C110.031 37.2071 109.246 36.78 108.543 36.2745C108.543 36.2745 105.765 34.6323 103.238 35.0363L92.4239 39.222C92.982 41.8328 92.3049 44.1917 90.6668 44.8641L86.1988 33.3538C87.8627 32.7482 89.9535 34.0345 91.3043 36.3394L102.119 32.1537C104.257 30.7504 105.2 27.6679 105.2 27.6679C105.379 26.8206 105.672 25.9762 106.07 25.1414C105.689 24.6458 105.369 24.0906 105.132 23.4788C103.798 20.0395 105.513 16.1574 108.956 14.8265C111.45 13.8597 114.178 14.4955 116 16.2254Z",
    fill: "#F1CE6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.104 37.4407C114.059 39.8605 116.84 41.0637 119.303 40.1265C120.85 39.5387 121.91 38.2413 122.247 36.7602C118.922 37.5499 115.688 37.5759 112.935 36.9281C112.98 37.0998 113.036 37.2699 113.104 37.4407ZM105.206 26.5675C105.385 25.7345 105.679 24.9044 106.076 24.0837C110 32.8305 123.424 31.4833 123.424 31.4833L125.159 35.8768C124.857 35.99 124.554 36.0956 124.251 36.1936C124.073 38.6551 122.487 40.923 119.992 41.8715C116.551 43.1813 112.662 41.4975 111.327 38.1177C111.09 37.5162 110.951 36.9022 110.897 36.2899C110.039 35.9464 109.254 35.5264 108.55 35.0294C108.55 35.0294 105.773 33.4145 103.246 33.8114L92.432 37.9254C92.9903 40.4922 92.3136 42.8113 90.6755 43.4722L86.2063 32.1554C87.87 31.5602 89.961 32.8251 91.3121 35.0913L102.126 30.9773C104.264 29.5979 105.206 26.5675 105.206 26.5675Z",
    fill: "#DAB659"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.788 117.741C151.788 117.741 151.857 119.356 151.189 119.99C150.522 120.625 148.265 122.043 148.257 123.278C148.249 124.512 148.796 125.277 149.407 125.681C149.998 126.076 149.344 128.447 150.624 128.711C151.906 128.974 153.148 128.429 153.637 127.795C154.128 127.16 155.142 127.591 156.078 126.491C157.013 125.391 158.831 124.678 157.571 121.223C156.311 117.768 155.355 114.884 155.355 114.884L151.788 117.741Z",
    fill: "#DBA585"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8742 32.9603C99.8742 32.9603 100.391 36.2016 99.8793 36.3494C99.3684 36.4967 99.0902 36.2399 99.0902 36.2399L98.6988 37.6709C98.6988 37.6709 97.9059 38.4709 97.2661 37.3715C97.2661 37.3715 96.6024 38.1969 96.1113 37.0623C96.1113 37.0623 95.4301 37.4103 95.1103 36.9238C94.79 36.4394 94.5443 34.3402 94.5443 34.3402C94.5443 34.3402 94.6903 33.8723 95.5214 33.9194C95.5214 33.9194 95.8935 33.2241 96.6723 33.3576C96.6723 33.3576 97.0573 32.8467 97.8977 32.9977C97.8977 32.9977 98.8454 31.9282 99.7991 32.6285C99.7991 32.6285 99.8535 32.8231 99.8742 32.9603Z",
    fill: "#C99A7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.481 37.9998C101.481 37.9998 99.8732 36.0631 98.4698 35.3451C98.1533 35.1823 97.8117 35.0764 97.5202 35.2743C97.2311 35.4733 97.1889 36.0953 97.837 36.966C98.4839 37.8361 98.8706 39.2216 98.8706 39.2216C98.8706 39.2216 99.8335 39.9426 101.481 37.9998Z",
    fill: "#DBA585"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.03 194.117C138.03 194.117 139.219 199.208 139.698 200.883C140.176 202.564 142.883 206.168 143.361 207.849C143.839 209.524 143.201 210.425 142.384 210.606C141.567 210.787 139.442 211.168 136.919 210.219C134.398 209.276 133.167 205.682 131.815 203.689C130.547 201.827 129.085 201.27 129.896 198.72C130.942 195.426 130.567 194.069 130.567 194.069L138.03 194.117Z",
    fill: "#232536"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.613 171.931L101.733 174.394L107.577 171.319L106.456 168.856L100.613 171.931Z",
    fill: "#42466C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.842 171.656C108.842 171.656 103.481 173.287 102.042 174.12C100.601 174.953 99.36 179.133 95.4733 181.464C91.5866 183.793 91.9272 186.469 92.5616 186.844C93.1966 187.22 104.558 182.035 106.799 180.593L108.059 179.251L109.455 179.541L113.104 177.682C113.104 177.682 111.843 172.926 108.842 171.656Z",
    fill: "#232536"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.657 114.566C132.657 114.566 134.686 122.337 134.65 127.904C134.614 133.474 133.956 150.863 134.483 153.612C135.012 156.362 135.943 169.108 136.085 171.398C136.226 173.688 139.417 198.501 139.417 198.501C139.417 198.501 135.661 200.693 127.483 199.032C127.483 199.032 127.183 173.247 126.739 169.431C126.297 165.614 124.974 153.094 124.048 151.715C123.121 150.335 115.226 117.098 116.435 111.08C117.644 105.06 132.657 114.566 132.657 114.566Z",
    fill: "#2B2D43"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.207 109.494C110.207 109.494 90.5457 125.865 88.4163 129.429C86.288 132.994 84.9317 133.444 85.8096 137.256C86.6875 141.069 99.7994 171.842 99.793 172.833C99.7866 173.822 109.096 169.862 109.699 169.791C110.301 169.718 106.244 163.812 104.99 160.072C103.736 156.333 98.2317 141.144 97.1907 139.233C96.1502 137.323 118.449 125.817 120.798 123.016C123.147 120.212 122.259 106.399 110.207 109.494Z",
    fill: "#2B2D43"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.648 117.219C156.648 117.219 153.111 119.488 151.804 118.961C150.497 118.434 145.512 99.5906 144.954 96.7986C144.395 94.0083 139.98 86.966 139.98 86.966C139.98 86.966 139.978 86.9699 139.974 86.9776C139.973 86.9798 139.971 86.9814 139.971 86.9853C139.969 86.9891 139.968 86.993 139.965 86.9968C139.698 87.5161 136.016 94.7158 135.172 98.3661C134.294 102.154 131.811 108.984 131.811 108.984L129.841 113.463L111.23 112.268L106.21 111.439C106.21 111.439 107.8 105.956 108.573 103.032C109.064 101.173 110.036 97.6855 110.63 94.3889C110.635 94.3718 110.637 94.3547 110.64 94.3375C110.648 94.2973 110.654 94.2537 110.663 94.2134C110.666 94.1963 110.669 94.1808 110.671 94.1637C110.988 92.3514 112.415 91.0447 112.349 89.6785C112.167 85.8614 113.478 82.7473 113.524 82.6062L114.904 75.4528C114.629 75.8218 106.178 65.7799 105.032 65.9465C103.865 66.1163 96.9203 44.1589 96.0076 42.8768C95.0312 41.5086 100.141 40.7495 100.141 40.7495L106.009 59.159L113.514 67.1699C113.703 67.0761 116.083 67.6777 117.628 67.306C120.001 66.7347 123.3 65.9826 125.414 65.5035C126.655 65.2231 127.489 65.0374 127.489 65.0374C127.489 65.0374 135.71 65.9371 136.33 66.1052C136.525 66.1561 137.419 66.6873 138.585 67.4242C141.105 69.0184 144.893 71.5771 145.608 72.3475C146.656 73.4758 151.186 93.0877 151.647 94.5061C152.106 95.924 156.648 117.219 156.648 117.219Z",
    fill: "#24B275"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.933 109.009C107.933 109.009 107.275 109.484 106.57 111.894C106.57 111.894 128.747 113.719 131.242 113.247C131.242 113.247 131.943 110.577 131.466 110.437C130.944 110.285 107.933 109.009 107.933 109.009Z",
    fill: "#3A3D5D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.891 65.1824C135.092 68.3223 127.88 68.7697 127.88 68.7697C127.88 68.7697 125.77 65.0352 126.524 64.8573C126.817 64.787 127.037 64.3288 127.195 63.7996C127.344 63.2954 127.437 62.7259 127.488 62.3624C127.519 62.1365 127.533 61.9884 127.533 61.9884C127.533 61.9884 128.719 61.2502 130.213 60.3856C132.82 58.8756 136.364 56.9748 136.143 57.9543C136.131 58.0045 136.108 58.0661 136.075 58.1345C135.042 60.2343 135.891 65.1824 135.891 65.1824Z",
    fill: "#DBA585"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.744 60.4621C134.727 60.4799 134.375 60.8478 133.796 61.3626C132.571 62.4508 130.328 64.1883 128.108 64.5951C128.247 64.0369 128.334 63.4066 128.381 63.0042C128.172 62.953 127.967 62.8799 127.768 62.7841C128.537 61.8581 129.565 60.9372 129.565 60.9372L130.913 60.8132L134.744 60.4621Z",
    fill: "#997761"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.474 58.5624C135.665 59.6449 134.954 60.4027 134.733 60.7162C134.587 60.9208 134.247 61.2292 133.771 61.5629C132.475 62.4722 130.193 63.556 128.269 63.1043C128.056 63.0561 127.848 62.9872 127.646 62.897C126.9 62.5663 126.053 62.018 125.753 60.9294C123.378 52.3401 127.616 46.591 127.616 46.591C127.616 46.591 139.226 45.7829 140.254 49.401C140.975 51.9376 138.372 56.0221 136.474 58.5624Z",
    fill: "#DBA585"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.405 46.0899C127.405 46.0899 126.357 45.8163 126.513 43.8042C126.669 41.8156 127.306 41.3868 127.306 41.3868C127.306 41.3868 129.228 42.0856 133.782 41.0982C135.488 40.7278 140.127 41.2126 140.868 42.4994C140.868 42.4994 143.353 42.4439 143.181 46.4086C142.905 52.7035 137.131 57.6935 137.131 57.6935C137.131 57.6935 138.018 53.725 137.232 53.0163C136.447 52.3075 135.403 53.4033 135.403 53.4033L133.495 53.3501C133.495 53.3501 137.543 48.0373 134.24 47.1382C130.937 46.2386 129.25 46.8212 127.405 46.0899Z",
    fill: "#2C3548"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.249 51.951C135.85 50.3225 139.563 50.3174 138.897 52.0182C138.232 53.7179 136.068 55.0808 135.273 54.8786C134.478 54.6775 134.793 53.1922 135.249 51.951Z",
    fill: "#DBA585"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.834 96.8002C145.546 99.5548 149.775 117.853 151.081 118.381C152.386 118.908 156.652 116.56 156.652 116.56C156.652 116.56 151.979 95.9262 151.52 94.5093C151.059 93.0919 146.534 73.4937 145.487 72.3662C144.883 71.7158 142.086 69.7869 139.714 68.2467C139.281 67.9634 138.86 67.6934 138.47 67.4463C137.795 67.9383 126.908 75.9812 125.898 84.8937C125.594 87.571 125.027 91.9228 124.813 96.5843C124.587 101.427 124.96 105.716 125.971 109.755C128.482 119.801 132.77 124.482 132.77 124.482L142.999 118.58C143.971 118.02 144.277 116.772 143.676 115.829C141.011 111.645 135.225 104.059 136.201 99.4065C136.201 99.4065 138.637 89.2704 139.859 86.9861C139.859 86.9861 144.014 93.6414 144.834 96.8002Z",
    fill: "#363957"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.275 57.2413L100.212 40.7499C100.212 40.7499 94.4178 40.7714 94.4962 41.9606C94.5463 42.7098 98.4758 60.0243 99.4572 61.5286C100.16 62.6017 112.619 78.2245 112.892 77.8564L112.126 82.9309C110.781 88.5484 110.709 92.5869 109.447 96.901C107.014 105.217 101.209 111.626 99.4345 114.804C99.1384 115.336 99.0881 116.076 99.4436 116.57L100.541 118.705C100.541 118.705 107.978 111.731 109.222 107.889C110.425 104.18 112.718 99.1954 114.317 94.355C116.346 88.2147 118.391 82.141 119.683 78.5904C123.055 69.3517 124.965 65.8525 124.965 65.8525L124.923 65.8026C124.243 65.9564 123.457 66.2621 122.584 66.3363C120.633 66.5044 115.858 66.3021 114.213 66.2303C114.213 66.2303 107.104 60.3982 105.275 57.2413Z",
    fill: "#363957"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.285 75.3327L131.607 76.4447L132.715 78.0903L124.766 96.5899C124.987 91.9275 125.576 87.575 125.891 84.8972C126.94 75.9832 138.265 67.9414 138.967 67.4496C139.373 67.6968 139.81 67.9669 140.261 68.2504L135.285 75.3327Z",
    fill: "#404367"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.356 65.9758C126.356 65.9758 123.767 70.194 119.354 81.1021C117.663 85.2942 114.987 92.4654 112.331 99.7154L116.302 78.2947L118.715 76.7575L117.418 74.477L123.147 66.6325C124.269 66.4016 125.322 66.1852 126.215 66.0042L126.356 65.9758Z",
    fill: "#404367"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.865 68.8409C141.347 70.3971 146.243 73.0313 146.875 73.6906C147.971 74.8274 150.74 93.9377 151.222 95.3694L138.865 68.8409Z",
    fill: "#363957"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.375 71.6948C126.375 71.6948 125.251 81.5052 132.307 84.249C139.36 86.9927 148.11 94.2073 150.421 97.761L153.196 102.342L153.989 97.9377C153.989 97.9377 153.838 90.4323 132.744 83.4854C132.744 83.4854 126.586 82.0489 128.643 71.9098C128.643 71.9098 126.409 71.2635 126.375 71.6948Z",
    fill: "#3063E4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.931 71.5605C124.931 71.5605 126.594 73.5382 129.096 72.768C129.096 72.768 128.941 69.0297 128.451 68.7899C127.961 68.5521 124.807 70.8604 124.931 71.5605Z",
    fill: "#3063E4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.235 67.4023L135.987 65.1961C135.987 65.1961 135.62 66.664 128.479 69.1433L129.226 74.8964L138.235 67.4023Z",
    fill: "#EEE0D7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.031 64.256C127.031 64.256 126.827 65.7493 127.76 68.8403L123.56 72.5856L124.775 65.3078L127.031 64.256Z",
    fill: "#EEE0D7"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 95.4756,
    y: 19.2098,
    width: 5.87354,
    height: 15.5229,
    rx: 2.93677,
    transform: "rotate(-131.011 95.4756 19.2098)",
    fill: "#FFABAB"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1846,
    y: 11.5791,
    width: 5.87354,
    height: 15.5229,
    rx: 2.93677,
    transform: "rotate(-83.8385 57.1846 11.5791)",
    fill: "#CBD8F8"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7153,
    y: 27.0138,
    width: 5.87354,
    height: 8.93245,
    rx: 2.93677,
    transform: "rotate(-34.0722 58.7153 27.0138)",
    fill: "#FFABAB"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 75.8579,
    y: 19.8969,
    width: 5.87354,
    height: 8.19727,
    rx: 2.93677,
    transform: "rotate(67.5663 75.8579 19.8969)",
    fill: "#5BC597"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9331,
    y: 2.98656,
    width: 5.87354,
    height: 15.5229,
    rx: 2.93677,
    transform: "rotate(-30.5624 75.9331 2.98656)",
    fill: "#5BC597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportComplete);
export default __webpack_public_path__ + "static/media/import-complete.7ec0ee4cd701f335f0357a380624737e.svg";
export { ForwardRef as ReactComponent };